import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AuthGuardService } from './services/authGuard.service';

const routes: Routes = [
  { path: 'login', loadChildren: './public/login/login.module#LoginPageModule' },
  { path: '', loadChildren: './public/login/login.module#LoginPageModule' },
  {
    path: 'members',
    loadChildren: './tabs/tabs.module#TabsPageModule'
  },
  {
    path: 'performa-invoice',
    loadChildren: () => import('./performa-invoice/performa-invoice.module').then( m => m.PerformaInvoicePageModule)
   },
  


  // {
  //   path: 'new-product',
  //   loadChildren: () => import('./new-product/new-product.module').then( m => m.NewProductPageModule)
  // }

  // {
  //   path: 'select-location',
  //   loadChildren: () => import('./select-location/select-location.module').then( m => m.SelectLocationPageModule)
  // },
  // { path: 'test', loadChildren: './test/test.module#TestPageModule' },
  // {
  //   path: 'performa-invoice-pdf',
  //   loadChildren: () => import('./performa-invoice-pdf/performa-invoice-pdf.module').then( m => m.PerformaInvoicePdfPageModule)
  // }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
